var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form_ct flex",staticStyle:{"margin-top":"20px"}},[_c('p',{staticClass:"upLoad_text"},[_vm._v("风格：")]),_c('div',{staticClass:"upload_box"},[_c('el-cascader',{attrs:{"options":_vm.style_list},on:{"change":_vm.handleChange},model:{value:(_vm.style),callback:function ($$v) {_vm.style=$$v},expression:"style"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }